import React from 'react';

export interface PredictionsSectionTitleProps
  extends React.HTMLProps<HTMLDivElement> {
  text: string;
}

const PredictionsSectionTitle: React.FC<PredictionsSectionTitleProps> = ({
  text,
  ...props
}) => (
  <div
    className={`text-[1.2rem] font-normal leading-[1.8rem] text-[#5f636d] mb-[1.2rem] ${props.className || ''}`}
    {...props}
  >
    {text}
  </div>
);

export default PredictionsSectionTitle;
